import { createApi } from "@reduxjs/toolkit/query/react";
import { setToken } from "../../features/userSlice";
import CustomFetchBase from "../CustomFetchBase";

export const AuthApi = createApi({
  reducerPath: "AuthApi",
  baseQuery: CustomFetchBase,
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (data) => ({
        url: "/index.php?VALUE=login",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);
          
          console.log(data?.token_id);

          dispatch(setToken(data?.token_id));
        } catch (error) {}
      },
      invalidatesTags: ["AuthApi"],
    }),
    // login: builder.mutation({
    //   query: (data) => ({
    //     url: "/user/login",
    //     method: "POST",
    //     body: data,
    //     headers: {
    //       "Content-Type": "application/json; charset=UTF-8",
    //     },
    //   }),
    //   invalidatesTags: ["AuthApi"],
    // }),
    // verifyOTP: builder.mutation({
    //   query: (data) => ({
    //     url: "/user/verifyOtp",
    //     method: "POST",
    //     body: data,
    //     headers: {
    //       "Content-Type": "application/json; charset=UTF-8",
    //     },
    //   }),
    //   invalidatesTags: ["AuthApi"],
    // }),
    // createAccount: builder.mutation({
    //   query: (data) => ({
    //     url: "/user/signUp",
    //     method: "POST",
    //     body: data,
    //     headers: {
    //       "Content-Type": "application/json; charset=UTF-8",
    //     },
    //   }),
    //   invalidatesTags: ["AuthApi"],
    // }),
    // getViewUserProfile: builder.query({
    //   query: (phoneNumber) => ({
    //     url: `/user/viewUserProfile/${phoneNumber}`,
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json; charset=UTF-8",
    //     },
    //   }),
    //   providesTags: ["AuthApi"],
    // }),
  }),
});

export const {
  useLoginUserMutation,
  // useLoginMutation,
  // useVerifyOTPMutation,
  // useGetViewUserProfileQuery,
  // useGetViewMyQuotesQuery,
} = AuthApi;
